"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogTransmitter = exports.createLoggerWithDefaults = exports.createLogger = void 0;
const defaultBrowserLogger_1 = __importDefault(require("./defaultBrowserLogger"));
var createLogger_1 = require("../common/createLogger");
Object.defineProperty(exports, "createLogger", { enumerable: true, get: function () { return __importDefault(createLogger_1).default; } });
var defaultBrowserLogger_2 = require("./defaultBrowserLogger");
Object.defineProperty(exports, "createLoggerWithDefaults", { enumerable: true, get: function () { return defaultBrowserLogger_2.createLoggerWithDefaults; } });
var createLogTransmitter_1 = require("./createLogTransmitter");
Object.defineProperty(exports, "createLogTransmitter", { enumerable: true, get: function () { return __importDefault(createLogTransmitter_1).default; } });
exports.default = defaultBrowserLogger_1.default;
